import React, { useEffect, useState } from 'react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { useShellRootContext } from 'src/contexts/ShellRoot';
import { Logger } from 'src/utils/Logger';

const LaunchDarkly: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [LDProvider, setLDProvider] = useState<React.ComponentType<any> | null>(
    null
  );
  const {
    interfaces: { v1 }
  } = useShellRootContext();

  useEffect(() => {
    const getLDClientSideID = () => {
      const stack = v1.app.getPortalStack();

      Logger.log(`LaunchDarkly stack, based on portal stack: ${stack}`);

      // Temporary mapping of stack to client-side ID
      // This should be replaced once we correctly configure LaunchDarkly with ClientOS on PCES-3947
      return {
        '0': '6823a88ba789b10911f76074',
        '1': '6823a88baa9c5f0913785334',
        '2': '6823a88b46db510911cfc5c7',
        '3': '6823a88bc3425e092ea19761'
      }[stack];
    };

    const fetchFeatureFlags = async () => {
      try {
        const ldProvider = await asyncWithLDProvider({
          clientSideID: getLDClientSideID(),
          reactOptions: {
            useCamelCaseFlagKeys: false
          },
          user: {
            key: 'anonymous'
          }
        });
        setLDProvider(() => ldProvider);
      } catch (error) {
        Logger.error('Failed to initialize LaunchDarkly:', error);
      }
    };

    fetchFeatureFlags();
  }, [v1.app]);

  return LDProvider ? React.createElement(LDProvider, null, children) : null;
};

export default LaunchDarkly;
